import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import { API_ENDPOINT } from "../../app.config";
import { BehaviorSubject } from 'rxjs';
import { ISearchFilter, Itinerary } from '../../common/models/TripPlanner.model';
import * as moment from 'moment';

export interface TripPlannerNavParams {
  reservationId?:any, itineraryId?:any, view?:string, active_date?: string; defaultTab?: string;
}

let headers: HttpHeaders;

@Injectable()
export class TripPlannerService {
  params: TripPlannerNavParams = {view:''};
  itinerary: BehaviorSubject<Itinerary> = new BehaviorSubject(null);
  lastSearch: ISearchFilter = null;
  constructor(
    private http: HttpClient,
    private router: Router
  ) {
  }

  setTripPlannerParams(params:TripPlannerNavParams) {
    this.params = {...this.params, ...params};
    console.log('::: trip planer params', this.params);
    headers = this.getRequestHeaders();
  }

  validateItineraryVisibility(itineraryId): Observable<any> {
    return this.http.get(API_ENDPOINT + 'v1/Itinerary/validateItineraryVisibility/' + itineraryId, {headers})
      .map((res:any) => res.data);
  }

  setItinerary(itinerary: Itinerary) {
    this.itinerary.next({...this.itinerary.value, ...itinerary});
  }

  getItinerary(): Observable<Itinerary> {
    return this.itinerary.asObservable();
  }

  getAvailabledates(): string[] {
    const itinerary = this.itinerary.value;
    return itinerary.date_range;
  }

  getAvailableTimes(): string[] {
    const availableTimes = [];
    new Array(24).fill(undefined).forEach((acc, index) => {
      availableTimes.push(moment({hour: index} ).format('h:mm A'));
      for (let minute = 5; minute < 60; minute+=5) {
        availableTimes.push(moment({ hour: index, minute }).format('h:mm A'));
      }
    });
    return availableTimes;
  }

  loadItinerary(itineraryId, force = false): void {
    if (!force && this.params.itineraryId && this.itinerary.value && this.params.itineraryId == this.itinerary.value.id) return;
    console.log('::: fetching itinerary');
    this.http.get(API_ENDPOINT + 'v1/Itinerary/getItineraryDetails/' + itineraryId, {headers})
      .map((res:any) => res.data)
      .subscribe(itinerary => this.setItinerary(itinerary),
        err => {
          const path = this.params.view === 'investor' ? '/dashboard' : '/admin/dashboard';
          this.router.navigate([path]);
        });
  }

  validateBookingParameters(itineraryId, activityId, bookingId): void {
    const body = {itineraryId, activityId, bookingId};
    this.http.post(API_ENDPOINT + 'v1/Itinerary/validateBookingParameters', body, {headers})
      .subscribe(() => console.info(':::: valid booking parameters'), err => {
        const path = this.params.view === 'investor' ? '/dashboard' : '/admin/dashboard';
        this.router.navigate([path]);
      });
  }

  setLastSearch(search: ISearchFilter) {
    this.lastSearch = search;
  }

  public getRequestHeaders(): HttpHeaders {
    let voyagerOrigin = '';
    if (this.params.view) {
      voyagerOrigin = this.params.view;
    } else {
      const location = window.location.href;
      voyagerOrigin = location.includes('#/admin/') ? 'ptc' : 'investor';
    }
    return new HttpHeaders()
      .set('x-voyager-origin', voyagerOrigin)
      .set('Content-Type', 'application/x-www-form-urlencoded');
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/services/trip-planner.service.ts